module.exports = __webpack_public_path__ + "img/landing-logo.935c4617.png";